/** @format */

export enum ACTION {
  LOGIN_USER = 'LOGIN_USER',
}
